interface IProps {
  address: string;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ReceiveViewContent = ({ address, onClickCopyBtn }: IProps) => {
  return (
    <div className="receive-container">
      <div className="receive-qr-code-container">
        <img
          src={`${import.meta.env.VITE_QR_CODE_URL}${address}`}
          alt="QR Code"
        />
      </div>
      <div className="receive-content">
        <div className="receive-content-row">
          <span className="receive-content-label text-xs">{address}</span>
          <button className="receive-content-copy-btn" onClick={onClickCopyBtn}>
            <img src="./images/copy-icon.png" alt="복사" className="copy-icon-small" />
          </button>
        </div>
        <p className="receive-content-notice text-base center">
          QR을 스캔하거나 주소를 복사해
          <br /> 상대방에게 공유해 주세요.
        </p>
      </div>
    </div>

  );
};

export default ReceiveViewContent;
